export function downloadArquivo(arquivo) {
  // Decodifica o conteúdo base64 para um array de bytes
  const byteCharacters = atob(arquivo.arquivo);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // Cria um Blob a partir do array de bytes
  const blob = new Blob([byteArray], { type: "application/octet-stream" });

  // Cria uma URL para o Blob
  const url = URL.createObjectURL(blob);

  // Cria um link de download
  const a = document.createElement("a");
  a.href = url;
  a.download = arquivo.nomeDocumento; // Nome do arquivo a ser baixado

  // Adiciona o link ao documento
  document.body.appendChild(a);

  // Simula um clique no link para iniciar o download
  a.click();

  // Remove o link do documento
  document.body.removeChild(a);

  // Limpa a URL criada
  URL.revokeObjectURL(url);
}
